import AdminService from "external-services/diary-admin-service/admin.service";
import BookingService from "app/services/booking/booking.service";
import { LocaleService } from 'internal-services/locale/locale.service';

export default function ExportExcelReportDialogCtrl(
  $scope, $filter, bookings, date, generatedDate, services, selectedSectionIds) {
  "ngInject";

  var vm = this;
  vm.bookings = bookings;
  vm.date = date;
  vm.generatedDate = generatedDate;
  vm.services = services;
  vm.selectedSectionIds = selectedSectionIds;

  // methods
  vm.exportExcelFile = exportExcelFile;

  // variables
  vm.dateRangeExport = false;
  vm.toDate = new Date();
  vm.fromDate = vm.date;
  vm.errorMessage = 'Invalid Date Range';

  // online status
  vm.isOnlineCustomersEnabled = AdminService.getVenue().isOnlineCustomersEnabled;

  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.INVALID = 2;
  vm.ERROR = 3;
  vm.state = vm.LOADING;

  var listeners = [];
  listeners.push($scope.$watch('vm.toDate', dateRangeChange));
  listeners.push($scope.$watch('vm.fromDate', dateRangeChange));
  listeners.push($scope.$watch('vm.dateRangeExport', dateRangeChange));

  // init
  function dateRangeChange() {
    vm.state = vm.INVALID;
    vm.errorMessage = 'Invalid Date Range';

    if (vm.dateRangeExport) {
      if (vm.toDate && vm.fromDate) {
        vm.toDate.setHours(0, 0, 0, 0);
        vm.fromDate.setHours(0, 0, 0, 0);

        if (vm.toDate.getTime() >= vm.fromDate.getTime()) {
          vm.state = vm.ENTER;
        }

        if (((vm.toDate - vm.fromDate) / 1000 / 60 / 60 / 24) > 31) {
          vm.state = vm.INVALID;
          vm.errorMessage = 'Exceeded maximum of 31 days';
        }
      }
    } else {
      vm.toDate = vm.fromDate;
      vm.state = vm.ENTER;
    }
  }

  function exportExcelFile() {
    vm.state = vm.LOADING;

    var dateString = vm.dateRangeExport ? LocaleService.formatDate(vm.fromDate, 'medium') + ' - ' + LocaleService.formatDate(vm.toDate, 'medium') : LocaleService.formatDate(vm.date, 'medium');
    var fileName = 'Booking_options_report ' + dateString +
      ' (generated ' + $filter('date')(vm.generatedDate, 'M.d.yy h:mm a') + ')';

    BookingService.downloadExcelReport(vm.generatedDate, vm.fromDate, vm.toDate).then(result => {

      var blob = new Blob([result.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

      var fileURL = URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = fileURL;
      link.style = 'visibility:hidden';
      link.download = fileName + '.xlsx';
      document.body.append(link);
      link.click();
      document.body.removeChild(link);
      vm.state = vm.ENTER;
    }).catch((err) => {
      console.log("Error exporting Excel Report", err);
      vm.state = vm.ERROR;
    });
  }
}
